import React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {
  useStyles,
  useTranslations,
} from "examsbook-react-sdk/custom-hooks";
import { Box, Grid, Typography } from "@material-ui/core";
import { useTheme } from "../../constants/themeProvider";
import { useSelector } from "react-redux";
import LockIcon from '@material-ui/icons/Lock';

export default function CTabs(props) {
  const settingsData = useSelector((state) => state.settingsReducers.settingsData?.data);
  const certificateValue = settingsData?.data?.[0]
    ? settingsData?.data?.[0]?.customization?.certification
    : false;
  const { mySectionData, isCourseExpired } = props;
  const t = useTranslations();
  const theme = useTheme();
  const drawerToggle = localStorage.getItem("openDrawerStatus");

  const styles = {
    title: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "16px",
      display: "flex",
      justifyContent: "center",
      color: "#000000",
      textTransform: "capitalize",
      textAlign: "left",
    },
    titleResize: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "16px",
      display: "flex",
      justifyContent: "center",
      color: "#000000",
      textTransform: "capitalize",
      textAlign: "left",
      "@media (max-width: 767px)": {
        width: "100%",
        textAlign: "center",
        fontSize: "11px",
        fontWeight: 700,
      },
    },
    iconTab: {
      alignItems: "center",
    },
    iconTabSelected: {
      borderBottom: `1px solid ${theme?.primaryColor}`,
      alignItems: "center",
      opacity: "1",
    },
    activeLogo: {
      transition: ".2s all linear",
    },
    activeTitle: {
      color: theme?.primaryColor,
      fontSize: "16px",
      fontWeight: 600,
      "@media (max-width: 767px)": {
        fontSize: 11,
        fontWeight: 700,
      },
      "@media (min-width: 960px) and (max-width: 1200px)": {
        fontSize: "11px",
        fontWeight: 700,
      },
    },
  };

  const classes = useStyles(styles)();

  return (
    <Tabs
      value={props.selectedTab}
      aria-label="course tabs"
      indicatorColor="primary"
      style={{padding: '0px 16px'}}
    >
      <Grid item container lg={8}>
        {props?.nav?.map((item, index) => {
          const label = item.label;
          const isActive = props.selectedTab === index;
          const activeIcon = item.activeIcon;
          const isLiveClassTab = index === 1 && mySectionData?.data?.liveClass?.length === 0;
          const isEvaluationTestTab = index === 2 && mySectionData?.data?.evaluationTest?.length === 0;
          const shouldShowTab = index < 3 || (index === 3 && certificateValue === true && mySectionData?.data?.evaluationTest?.length !== 0);
          const isExpiredLocked = isCourseExpired && index > 0;
          if (isLiveClassTab || isEvaluationTestTab) return null;
          return (
            shouldShowTab && (
              <Grid item xs={3} md={3} lg={3} onClick={() => props.handleTabChange(index)} key={index}>
                <Tab
                  style={{ width: "100%" }}
                  label={
                    <Box className="feature-buttons">
                      <Box
                        className={`${
                          drawerToggle && window.innerWidth < 1200
                            ? classes.logoResize
                            : classes.logo
                        } ${isActive ? classes.activeLogo : ""} `}
                      >
                        <Box
                          className={`${
                            drawerToggle && window.innerWidth < 1200
                              ? classes.titleResize
                              : classes.title
                          } ${isActive && !isExpiredLocked ? classes.activeTitle : ""}`}
                          style={isExpiredLocked ? { opacity: 0.5 } : {}}
                        >
                          {isExpiredLocked && <LockIcon style={{ fontSize: '14px', marginRight: '4px', color: '#9e9e9e' }} />}
                          <Typography variant="inherit">{t(label)}</Typography>
                        </Box>
                      </Box>
                    </Box>
                  }
                  key={index}
                  className={
                    isActive ? classes.iconTabSelected : classes.iconTab
                  }
                />
              </Grid>
            )
          );
        })}
      </Grid>
    </Tabs>
  );
}
